export let DataLayer = {};

DataLayer.install = function (Vue, options) {
    Vue.prototype.$dataLayer =  {
        push: function(obj) {
            if(window.dataLayer) {
                dataLayer.push(obj);
            }
        }
    }
};
